/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minus': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M2.25 10.125v-2.25h13.5v2.25z" _fill="#566473" fill-rule="evenodd"/>'
  }
})
